import { AuthMessage } from '../interfaces/auth-message.interface';

export const Messages: AuthMessage[] = [
  // UNIFY different cases to lowercase
  { code: '', messageKey: '' },
  { code: '-default-message', messageKey: 'AUTH_ERROR_UNKNOWN' },
  { code: 'auth_login', messageKey: 'AUTH_LOGIN_ERROR_BLOCKED' },
  {
    code: 'auth_login_temporary',
    messageKey: 'AUTH_LOGIN_ERROR_BLOCKED_TEMPORARY',
  },
  { code: 'auth_disabled', messageKey: 'AUTH_LOGIN_ERROR_BLOCKED' },
  { code: 'auth_unknown', messageKey: 'AUTH_LOGIN_ERROR_CREDENTIALS' },
  {
    code: 'cant_update_password_please_contact_admin',
    messageKey: 'AUTH_RESET_PASSWORD_ERROR_CONTACT_ADMIN',
  },
  { code: 'code_entity_send', messageKey: 'AUTH_MFA_CODE_SENT_SUCCESSFULLY' },
  {
    code: 'have_problem_in_sending_new_code',
    messageKey: 'AUTH_MFA_ERROR_RESEND_CODE',
  },
  {
    code: 'length_mismatch',
    messageKey: 'AUTH_RESET_PASSWORD_ERROR_LENGTH_NOT_EQUAL',
  }, // TODO: on BE rename to "length_mismatch"
  { code: 'mfa_wrong_code', messageKey: 'AUTH_MFA_ERROR_WRONG_CODE' },
  { code: 'mismatch', messageKey: 'AUTH_RESET_PASSWORD_ERROR_MISMATCH' },
  {
    code: 'password_no_capital',
    messageKey: 'AUTH_RESET_PASSWORD_ERROR_HAS_NO_CAPITAL',
  },
  {
    code: 'password_no_digit',
    messageKey: 'AUTH_RESET_PASSWORD_ERROR_HAS_NO_DIGIT',
  },
  {
    code: 'password_no_special',
    messageKey: 'AUTH_RESET_PASSWORD_ERROR_HAS_NO_SPECIAL',
  },
  {
    code: 'password_too_common',
    messageKey: 'AUTH_RESET_PASSWORD_ERROR_IS_TOO_COMMON',
  },
  {
    code: 'password_too_short',
    messageKey: 'AUTH_RESET_PASSWORD_ERROR_IS_TOO_SHORT',
  },
  {
    code: 'password_too_similar',
    messageKey: 'AUTH_RESET_PASSWORD_ERROR_IS_TOO_SIMILAR',
  },
  {
    code: 'same_password',
    messageKey: 'AUTH_RESET_PASSWORD_ERROR_IS_SAME_PASSWORD',
  },
  {
    code: 'sign_in_error_password_is_vulnerable',
    messageKey: 'AUTH_RESET_PASSWORD_ERROR_IS_VULNERABLE',
  },
  {
    code: 'password_compromised',
    messageKey: 'AUTH_RESET_PASSWORD_ERROR_IS_COMPROMISED',
  },
];
